let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ipYdy")).then(() => parcelRequire('2Wlt9'));